import React from 'react';
import styled from '@emotion/styled';
import FontAwesome from 'react-fontawesome';
import { assetUrl } from '~/helpers';
import { useFeatures } from '~/react-hooks/use-features';

const CenterContainer = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 35px;
  color: #ffffff;
  width: 100%;
`;

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  z-index: 99;
`;

const SuccessPosterFooter = styled.div`
  bottom: 0;
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const PopupTitle = styled.div`
  color: #ffffff;
  padding-bottom: 14px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;

const HomeLink = styled.a`
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 185px;
  color: #ffffff;

  :hover {
    text-decoration: none;
    color: #27b3c1;
  }
`;

export type RecorderStatusProps = {
  isLoading: boolean;
  isFailed: boolean;
  isComplete: boolean;
};
function RecorderStatus({
  isLoading,
  isFailed,
  isComplete,
}: RecorderStatusProps) {
  const { shouldHideBonjoroBranding } = useFeatures();

  function renderSuccessPoster() {
    return (
      <>
        <CenterContainer>
          <PopupTitle>Video Sent</PopupTitle>
          <img src={assetUrl('assets/images/record/ic_video_sent.svg')} />
        </CenterContainer>
        {!shouldHideBonjoroBranding && (
          <SuccessPosterFooter>
            <HomeLink href='/home'>
              <img
                src={assetUrl('assets/images/logos/bear-logo.png')}
                alt='Bonjoro logo'
                width={36}
              />
              Send your own Videos
            </HomeLink>
          </SuccessPosterFooter>
        )}
      </>
    );
  }

  function renderLoading() {
    return (
      <CenterContainer>
        <PopupTitle>Uploading...</PopupTitle>
        <FontAwesome name='spinner' className='spinning' />
      </CenterContainer>
    );
  }

  function renderFailedUpload() {
    return (
      <CenterContainer>
        <PopupTitle>Failed to Upload video, Please try again</PopupTitle>
        <FontAwesome name='exclamation-triangle' />
      </CenterContainer>
    );
  }
  return (
    <>
      {(isLoading || isLoading || isComplete) && (
        <OverlayContainer>
          {isFailed && renderFailedUpload()}
          {isLoading && renderLoading()}
          {isComplete && renderSuccessPoster()}
        </OverlayContainer>
      )}
    </>
  );
}

export default RecorderStatus;
